import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SpokesmenService } from 'src/app/core/services/api/spokesmen.service';
import { CustomerService } from 'src/app/core/services/api/customer.service';

import { Swal2 } from 'src/app/core/utils/swal2.util';
import { Observable } from 'rxjs';
import { ClienteVoceros } from 'src/app/core/contracts/models/cliente-voceros';
import { CargosService } from 'src/app/core/services/api/cargos.service';
import { CargosFormComponent } from 'src/app/pages/maintenance/media/cargos/form/cargos-form.component';


@Component({
    selector: 'app-asignar-clientes-form',
    templateUrl: './asignar-clientes-form.component.html',
    styleUrls: ['./asignar-clientes-form.component.scss']
})
export class AsignarClientesFormComponent implements OnInit {
    public loading: boolean = false;

    myForm = this.formBuilder.group({
        cliente_id: new FormControl<number | null>(null, [Validators.required]),
        cargo: new FormControl<number[] | null>(null),
        filter: new FormControl<string | null>(null),
        filterC: new FormControl<string | null>(null)
    });

    cliente: ClienteVoceros = {
        cliente_id: null,
        idVocero: null,
        cargo: null,
    }

    clientes: any[] = [];
    cargos: any[] = [];

    title = 'Agregar cliente';
    loader = true;

    constructor(
        private formBuilder: FormBuilder,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<AsignarClientesFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { row: ClienteVoceros, id: number },
        private customerService: CustomerService,
        private spokesmenService: SpokesmenService,
        private swal: Swal2,
        private cargosService: CargosService
    ) {
        if (data.row) {
            this.title = 'Editar cliente';
        }
    }

    ngOnInit(): void {

        this.customerService.getListSelect().subscribe((response: any) => {
            const { clientes } = response;
            this.clientes = clientes;
            this.loader = false;
        });

        this.cargosService.getAll().subscribe((response: any) => {
            const { cargos } = response;
            this.cargos = cargos;
            if (this.data.row) {
                const raw: any = (this.data.row as any).idsCargo || (this.data.row as any).ids_cargo || (this.data.row as any).cargos;
                let selectedIds: number[] = [];
                if (Array.isArray(raw)) {
                    if (raw.length && typeof raw[0] === 'object') {
                        selectedIds = raw.map((r: any) => Number(r.id ?? r.idCargo ?? r.cargo_id)).filter((v: number) => !isNaN(v) && v > 0);
                    } else {
                        selectedIds = raw.map((v: any) => Number(v)).filter((v: number) => !isNaN(v) && v > 0);
                    }
                } else if (typeof raw === 'string') {
                    const labels = raw.split(',').map((s: string) => s.trim()).filter((s: string) => !!s);
                    selectedIds = this.cargos.filter((c: any) => labels.includes(c.descripcion)).map((c: any) => c.id);
                } else if (typeof raw === 'number') {
                    selectedIds = [raw].filter(v => v > 0);
                }
                if (selectedIds.length) this.myForm.controls.cargo.setValue(selectedIds);
            }
        });

        if (this.data.row) {
            this.myForm.controls.cliente_id.setValue(this.data.row.cliente_id);
            this.myForm.controls.cliente_id.disable();
        }

    }

    onSubmit() {
        const selectedIds: number[] = this.myForm.controls.cargo.value || [];
        const payload: any = {
            idVocero: this.data.id,
            cliente_id: this.myForm.controls.cliente_id.value,
            idsCargo: selectedIds
        }

        let observable: Observable<any> | undefined = undefined

        if (this.data.row) {
            payload.id = (this.data.row as any).id;
            observable = this.spokesmenService.editClienteVoceros(payload)
        } else {
            observable = this.spokesmenService.createClienteVoceros(payload)
        }
        this.loading = true;
        observable.subscribe((response: any) => {
            this.dialogRef.close(response);
            this.loading = false;
            this.swal.showToast(response.message, 'success');
        }, error => {
            if (error.status === 400) {
                this.error(error);
            }
            this.loading = false;
        });
    }

    error(error: any) {
        if (error.error.errors.vocero_id) {
            this.swal.showToast(error.error.errors.vocero_id[0], 'error');
        }
    }

    addCargo(row?) {
        const dialogRef = this.dialog.open(CargosFormComponent, {
            data: row,
            width: '500px'
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.cargo) {
                const nuevoCargo = result.cargo;
                this.cargos.push(nuevoCargo);
                const seleccionActual = this.myForm.controls.cargo.value || [];
                if (!seleccionActual.includes(nuevoCargo.id)) {
                    this.myForm.controls.cargo.setValue([...seleccionActual, nuevoCargo.id]);
                }
                this.myForm.controls.filterC.setValue(null);
            }
        });
    }
}
